import React from "react";
import { Routes, Route } from "react-router-dom";
import ListTeamMembers from "../Components/Team Members/listTeamMembers";
import AddTeamMember from "../Components/Team Members/addTeamMember";
import EditTeamMember from "../Components/Team Members/EditTeamMember";
import ViewTeamMember from "../Components/Team Members/viewTeamMember";

const TeamRoutes = () => {
  return (
    <Routes>
      <Route path="/team" element={<ListTeamMembers></ListTeamMembers>}></Route>
      <Route path="/team/add" element={<AddTeamMember></AddTeamMember>}></Route>
      <Route
        path="/team/edit/:id"
        element={<EditTeamMember></EditTeamMember>}
      ></Route>
      <Route path="/team/view/:id" element={<ViewTeamMember />}></Route>
    </Routes>
  );
};

export default TeamRoutes;
